import {useEffect, useState} from "react";
import MDSpinner from "react-md-spinner";
import "./PaymentProcessing.scss"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import * as Actions from "./PaymentPorcessingApi"

const PaymentProcessing = ({actions, params}) => {
    const [status, setStatus] = useState('loading')
    const [isLoading, setIsLoading] = useState(true)


    useEffect(() => {
        const sessionID = params.sessionID

        const interval = setInterval(() => {
            actions.getPaymentStatus(sessionID, (res) => {
                if (res.status) {
                    setStatus(res.status)
                    setIsLoading(false)
                    clearInterval(interval)
                    setTimeout(() => {
                        window.location.href = `/customer_view/invoice/${params.token}`
                    }, 7000)
                }
            })
        }, 2500)
    }, []);

    return (
        <div className="payment-processing">
            {isLoading && (
                <>
                    <h1>Processing payment...</h1>
                    <MDSpinner/>
                </>
            )}
            {!isLoading && status === "processing" && (
                <>
                    <h1>Payment submitted</h1>
                    <p>Your ACH payment is processing. This can take a few business days.</p>
                    <p>You'll be redirected to your invoice page in a few seconds.</p>
                </>
            )}
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {actions: bindActionCreators(Actions, dispatch)}
}

export default connect(null, mapDispatchToProps)(PaymentProcessing);